module.exports = __webpack_public_path__ + "media/munches/big-ol-chomper-1-e99af979.svg";